import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * How many MCP connections the selected org has, for the sidebar badge.
 * `undefined` until loaded (no flashed 0), and fetched only for admins — the route
 * is admin-only and the API 403s everyone else. `bump` re-reads it after the page
 * adds or removes a connection (the sidebar has no event to listen to).
 */
export function useMcpCount(org: string, admin: boolean): number | undefined {
  const [count, setCount] = useState<number | undefined>(undefined);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const onChange = () => setTick((t) => t + 1);
    window.addEventListener(MCP_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(MCP_CHANGED_EVENT, onChange);
  }, []);

  useEffect(() => {
    if (!admin) {
      setCount(undefined);
      return;
    }
    let cancelled = false;
    api
      .getMcpConnections(org)
      .then((d) => {
        if (!cancelled) setCount(d.connections.length);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [org, admin, tick]);

  return count;
}

/** Fired by the MCP page when a connection is added or removed. */
export const MCP_CHANGED_EVENT = "omni-hub:mcp-changed";
export function notifyMcpChanged(): void {
  window.dispatchEvent(new Event(MCP_CHANGED_EVENT));
}
